import React from 'react';
import { createRoot } from 'react-dom/client';

import SearchForm from 'common/components/ui/SearchForm';
import readAttribute from 'common/tools/dom/readAttribute';

/**
 * Standalone search module.
 *
 * Mounts the very same <SearchForm /> used by the header search (autocomplete,
 * tracking, "view all results"...) on any page, as many times as needed.
 *
 * Anchor rendered by `module/search/inpage-search.html.twig`:
 *   <form ...><div class="js-search-module search-module" ...></div></form>
 *
 * Each instance gets a unique input id so it can coexist with the header search
 * and with other modules on the same page. No-op when no anchor is present.
 */
export default function initSearchModule() {
  const anchors = document.getElementsByClassName('js-search-module');
  if (!anchors.length) {
    return;
  }

  Array.from(anchors).forEach((anchor, index) => {
    const placeholder = readAttribute<string, undefined>(
      anchor,
      'data-placeholder'
    );

    const root = createRoot(anchor);
    root.render(
      <SearchForm
        inputId={`search-module-input-${index}`}
        placeholder={placeholder}
        context="inpage"
      />
    );
  });
}
